const roleRoutes = {
  commonRoutes: ['/login', '/logout', '/invitations', '/account', '/password', '/register', '/shopify/auth', '/app/auth/shopify/callback', '/shopify/app'],
  customerServiceRoutes: ['/orders', '/fulfillment', '/utilities/item-check', '/utilities/order-check', '/utilities/price-check'],
  channelOrganizationAdminRoutes: ['/organization/members', '/organization/accounts', '/fulfillment'],
  fulfilmentRoutes: ['/fulfillment'],
  classificationRoutes: ['/catalog', '/catalog/items'],
};

export default roleRoutes;
